"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _MuiAlert = _interopRequireDefault(require("./MuiAlert"));

var _MuiAutocomplete = _interopRequireDefault(require("./MuiAutocomplete"));

var _MuiAvatar = _interopRequireDefault(require("./MuiAvatar"));

var _MuiBackdrop = _interopRequireDefault(require("./MuiBackdrop"));

var _MuiButton = _interopRequireDefault(require("./MuiButton"));

var _MuiCardActions = _interopRequireDefault(require("./MuiCardActions"));

var _MuiCardContent = _interopRequireDefault(require("./MuiCardContent"));

var _MuiCardHeader = _interopRequireDefault(require("./MuiCardHeader"));

var _MuiCheckbox = _interopRequireDefault(require("./MuiCheckbox"));

var _MuiChip = _interopRequireDefault(require("./MuiChip"));

var _MuiDialogActions = _interopRequireDefault(require("./MuiDialogActions"));

var _MuiDialogTitle = _interopRequireDefault(require("./MuiDialogTitle"));

var _MuiFormHelperText = _interopRequireDefault(require("./MuiFormHelperText"));

var _MuiFormLabel = _interopRequireDefault(require("./MuiFormLabel"));

var _MuiInputAdornment = _interopRequireDefault(require("./MuiInputAdornment"));

var _MuiInputLabel = _interopRequireDefault(require("./MuiInputLabel"));

var _MuiLinearProgress = _interopRequireDefault(require("./MuiLinearProgress"));

var _MuiListItem = _interopRequireDefault(require("./MuiListItem"));

var _MuiListItemAvatar = _interopRequireDefault(require("./MuiListItemAvatar"));

var _MuiOutlinedInput = _interopRequireDefault(require("./MuiOutlinedInput"));

var _MuiRadio = _interopRequireDefault(require("./MuiRadio"));

var _MuiSnackbarContent = _interopRequireDefault(require("./MuiSnackbarContent"));

var _MuiStepConnector = _interopRequireDefault(require("./MuiStepConnector"));

var _MuiStepIcon = _interopRequireDefault(require("./MuiStepIcon"));

var _MuiSvgIcon = _interopRequireDefault(require("./MuiSvgIcon"));

var _MuiSwitch = _interopRequireDefault(require("./MuiSwitch"));

var _MuiTableCell = _interopRequireDefault(require("./MuiTableCell"));

var _MuiTextField = _interopRequireDefault(require("./MuiTextField"));

var _MuiTimelineConnector = _interopRequireDefault(require("./MuiTimelineConnector"));

var _MuiTimelineContent = _interopRequireDefault(require("./MuiTimelineContent"));

var _MuiTimelineDot = _interopRequireDefault(require("./MuiTimelineDot"));

var _MuiTimelineOppositeContent = _interopRequireDefault(require("./MuiTimelineOppositeContent"));

var _MuiTooltip = _interopRequireDefault(require("./MuiTooltip"));

var _WAMuiChipInput = _interopRequireDefault(require("./WAMuiChipInput"));

var _MuiPaper = _interopRequireDefault(require("./MuiPaper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(theme) {
  return {
    MuiAlert: (0, _MuiAlert["default"])(),
    MuiAutocomplete: (0, _MuiAutocomplete["default"])(theme),
    MuiAvatar: (0, _MuiAvatar["default"])(),
    MuiBackdrop: (0, _MuiBackdrop["default"])(theme),
    MuiButton: (0, _MuiButton["default"])(),
    MuiCardActions: (0, _MuiCardActions["default"])(),
    MuiCardContent: (0, _MuiCardContent["default"])(),
    MuiCardHeader: (0, _MuiCardHeader["default"])(),
    MuiCheckbox: (0, _MuiCheckbox["default"])(theme),
    MuiChip: (0, _MuiChip["default"])(theme),
    MuiDialogActions: (0, _MuiDialogActions["default"])(),
    MuiDialogTitle: (0, _MuiDialogTitle["default"])(),
    MuiFormHelperText: (0, _MuiFormHelperText["default"])(),
    MuiFormLabel: (0, _MuiFormLabel["default"])(),
    MuiInputAdornment: (0, _MuiInputAdornment["default"])(),
    MuiInputLabel: (0, _MuiInputLabel["default"])(),
    MuiLinearProgress: (0, _MuiLinearProgress["default"])(),
    MuiListItem: (0, _MuiListItem["default"])(theme),
    MuiListItemAvatar: (0, _MuiListItemAvatar["default"])(),
    MuiOutlinedInput: (0, _MuiOutlinedInput["default"])(theme),
    MuiRadio: (0, _MuiRadio["default"])(theme),
    MuiSnackbarContent: (0, _MuiSnackbarContent["default"])(theme),
    MuiStepConnector: (0, _MuiStepConnector["default"])(),
    MuiStepIcon: (0, _MuiStepIcon["default"])(theme),
    MuiSvgIcon: (0, _MuiSvgIcon["default"])(theme),
    MuiSwitch: (0, _MuiSwitch["default"])(theme),
    MuiTableCell: (0, _MuiTableCell["default"])(),
    MuiTextField: (0, _MuiTextField["default"])(),
    MuiTimelineConnector: (0, _MuiTimelineConnector["default"])(theme),
    MuiTimelineContent: (0, _MuiTimelineContent["default"])(),
    MuiTimelineDot: (0, _MuiTimelineDot["default"])(),
    MuiTimelineOppositeContent: (0, _MuiTimelineOppositeContent["default"])(),
    MuiTooltip: (0, _MuiTooltip["default"])(theme),
    WAMuiChipInput: (0, _WAMuiChipInput["default"])(theme),
    MuiPaper: (0, _MuiPaper["default"])(theme)
  };
};

exports["default"] = _default;